module.exports = __webpack_public_path__ + "static/aboutsm-6eeb92048b1c228c6a72bc7c6499c542.jpg";